import React, { useState } from 'react';
import { Phone, Mail, MapPin, MessageCircle, Send } from 'lucide-react';
import { CONTACT, BRAND } from '../lib/butterstone';

const ContactSection = () => {
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const submit = (e) => {
    e.preventDefault();
    const text = `Hi Butterstone River Valley!%0AName: ${form.name}%0APhone: ${form.phone}%0A${form.message}`;
    window.open(`https://wa.me/${CONTACT.whatsapp}?text=${text}`, '_blank');
  };
  return (
    <section id="contact" className="section-pad bg-[#EAF0E4]" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12">
        <div>
          <span className="overline">Get in touch</span>
          <h2 className="font-serif text-4xl md:text-6xl mt-4">Contact us</h2>
          <p className="text-[#3A4A3E] mt-4 max-w-md">Reach out to plan your riverside escape at {BRAND.name}, Sakleshpur.</p>
          <div className="mt-8 space-y-3">
            <a href={`tel:+91${CONTACT.phone1}`} className="flex items-center gap-4 leaf-card p-4" data-testid="contact-phone-1">
              <span className="w-11 h-11 rounded-full bg-[#2F5233] flex items-center justify-center"><Phone size={18} className="text-white" /></span>
              <span className="font-serif text-xl text-[#1E3226]">{CONTACT.phone1Display}</span>
            </a>
            <a href={`tel:+91${CONTACT.phone2}`} className="flex items-center gap-4 leaf-card p-4" data-testid="contact-phone-2">
              <span className="w-11 h-11 rounded-full bg-[#2F5233] flex items-center justify-center"><Phone size={18} className="text-white" /></span>
              <span className="font-serif text-xl text-[#1E3226]">{CONTACT.phone2Display}</span>
            </a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-4 leaf-card p-4" data-testid="contact-email">
              <span className="w-11 h-11 rounded-full bg-[#2F5233] flex items-center justify-center flex-shrink-0"><Mail size={18} className="text-white" /></span>
              <span className="text-[#1E3226] break-all">{CONTACT.email}</span>
            </a>
            <div className="flex items-center gap-4 leaf-card p-4">
              <span className="w-11 h-11 rounded-full bg-[#2F5233] flex items-center justify-center flex-shrink-0"><MapPin size={18} className="text-white" /></span>
              <span className="text-[#1E3226]">{BRAND.location}</span>
            </div>
          </div>
        </div>
        <form onSubmit={submit} className="leaf-card p-6 md:p-8" data-testid="contact-form">
          <h3 className="font-serif text-2xl text-[#1E3226] mb-5">Send an enquiry</h3>
          <div className="space-y-4">
            <div>
              <label className="text-xs tracking-wider uppercase text-[#5E6E60]">Name</label>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 w-full bg-white border border-[#2F5233]/25 rounded-md px-4 py-3 focus:outline-none focus:border-[#2F5233]" data-testid="contact-name" />
            </div>
            <div>
              <label className="text-xs tracking-wider uppercase text-[#5E6E60]">Phone</label>
              <input required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1 w-full bg-white border border-[#2F5233]/25 rounded-md px-4 py-3 focus:outline-none focus:border-[#2F5233]" data-testid="contact-phone" />
            </div>
            <div>
              <label className="text-xs tracking-wider uppercase text-[#5E6E60]">Message</label>
              <textarea rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1 w-full bg-white border border-[#2F5233]/25 rounded-md px-4 py-3 focus:outline-none focus:border-[#2F5233]" data-testid="contact-message" />
            </div>
            <button type="submit" className="btn-moss w-full justify-center" data-testid="contact-submit"><Send size={16} /> Send via WhatsApp</button>
            <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="btn-outline w-full justify-center"><MessageCircle size={16} /> Chat on WhatsApp</a>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
